<template>
  <div class="modal-wrap">
    <div class="modal-overlay" />

    <div class="modal-content" style="max-width: 100%; padding: 0 15px">
      <div class="payredirect-status-nav">
        <a class="payredirect-back" @click="goBack">Назад</a>
      </div>

      <v-form @submit="pay" v-slot="{ meta }" :validation-schema="schema">
        <div class="payredirect-line-0">
          <div class="payredirect payre-block-box1">
            <template v-if="isInput">
              <div class="payredirect-line-1">
                <div class="payredirect-title">Номер карты</div>
                <card-pan v-model="pan" name="pan" />
                <error-message name="pan" />
              </div>

              <div class="payredirect-line-2">
                <div class="payredirect-line-2-1">
                  <div class="payredirect-title">ММ/ГГ</div>
                  <v-field
                    name="month"
                    type="text"
                    class="payredirect-line-2-num-item-1"
                    @click="$event.target.select()"
                    placeholder="MM"
                    maxlength="2"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    @keypress="isNumber"
                    v-model="month"
                  />
                  <span>/</span>
                  <v-field
                    name="year"
                    type="text"
                    class="payredirect-line-2-num-item-2"
                    @click="$event.target.select()"
                    placeholder="ГГ"
                    maxlength="2"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    @keypress="isNumber"
                    v-model="year"
                  />
                </div>
                <div class="payredirect-line-2-2">
                  <div class="payredirect-title">CVV</div>
                  <v-field
                    name="cvv"
                    type="text"
                    class="payredirect-line-2-num-item-3"
                    @click="$event.target.select()"
                    placeholder="CVV"
                    maxlength="3"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    @keypress="isNumber"
                    v-model="cvv"
                  />
                  <div class="cvv" @click="this.showTooltip = !this.showTooltip">
                    <div class="level-item-q-p" v-if="this.showTooltip">
                      CVV - трехзначный код, обычно находится на обратной стороне Вашей карты.
                    </div>
                  </div>
                </div>
              </div>

              <div class="payredirect-line-3">
                <v-field
                  name="name"
                  type="text"
                  class="payredirect-line-3-num-item"
                  @click="$event.target.select()"
                  placeholder="Имя и фамилия"
                  v-model="name"
                />
                <error-message name="name" />
              </div>

              <div class="payredirect-line-4">
                <div class="save-card">
                  <button
                    type="button"
                    :class="`enter-card-favorite ${isSaveWallet ? 'active' : ''}`"
                    @click="isSaveWallet = !isSaveWallet"
                  ></button>
                  <div class="save-btn">Сохранить карту</div>
                </div>
                <button type="submit" :disabled="!meta.valid">Оплатить {{ amount }} ₽</button>
              </div>

              <a class="payredirect-close" @click="goBack"></a>
            </template>

            <template v-if="isPending">
              <object
                class="preloader-logo-site"
                type="image/svg+xml"
                data="/images/mln-logo-preloader-site.svg"
              ></object>
              <div class="preloader-logo-site-time">Ожидайте...</div>
            </template>

            <template v-else-if="isCompleted">
              <div class="iCompleted">
                <div>Успешная оплата</div>
                <button class="payredirect-submit1" @click="closeCashDesk">
                  {{ 'Хорошо' }}
                </button>
              </div>
            </template>

            <template v-else-if="isFailed">
              <div class="iError">
                <div>Не удалось совершить платеж</div>
                <div class="noRequisites">Проверьте данные карты или попробуйте другую.</div>
                <button class="payredirect-submit1" @click="goRetry">
                  {{ 'Вернуться' }}
                </button>
              </div>
            </template>
          </div>

          <div class="payre-block-box2">
            <div class="payre-block-box2-1">Инструкция по оплате:</div>
            <div class="payre-block-box2-2">
              Введите номер карты, месяц и год действия карты и CVV-код — это 3 цифры на обратной стороне карты.
            </div>
            <div class="payre-block-box2-3">
              Нажмите Оплатить и при необходимости подтвердите платёж через SMS или банковское приложение.
            </div>
            <div class="payre-block-box2-4">Ожидайте зачисление платежа в течение нескольких минут.</div>
          </div>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import VueCountdown from '@chenfengyuan/vue-countdown'
import { ErrorMessage, Field, Form, configure } from 'vee-validate'
import * as yup from 'yup'
import CardPan from '@/components/Fields/CardPan.vue'
import { FETCH_PAYMENT_STATUS, FETCH_PAYSYSTEM_CONFIG, SEND_PAYMENT } from '@/store/actions.type'
import { toast } from 'vue3-toastify'
import { postForm } from '@/utils/postForm'

const stateInput = 'input'
const stateCompleted = 'completed'
const stateFailed = 'failed'
const statePending = 'pending'

export default {
  name: 'InputCardData',
  props: ['amount', 'provider'],
  components: {
    CardPan,
    VueCountdown,
    VForm: Form,
    VField: Field,
    ErrorMessage,
  },
  emits: ['closeModal'],
  setup() {
    const { t, n } = useI18n()
    const showTooltip = ref(false)
    return { t, n, showTooltip }
  },
  mounted() {
    this.$store.dispatch(FETCH_PAYSYSTEM_CONFIG, this.provider).then(cfg => {
      if (cfg.wallet) {
        this.pan = cfg.wallet
      }
      this.isSaveWallet = cfg.isSaveWallet
    })
  },
  data() {
    return {
      ttl: 600,
      pan: '',
      month: '',
      year: '',
      cvv: '',
      name: '',
      isSaveWallet: true,
      state: stateInput,
      failedMessage: null,
      paymentId: null,
      interval: null,
      schema: yup.object().shape({
        pan: yup
          .string()
          .min(19, 'Введите корректный номер карты')
          .max(23, 'Введите корректный номер карты')
          .required('Поле обязательное'),
        month: yup.string().min(2).required('Поле обязательное'),
        year: yup.string().min(2).required('Поле обязательное'),
        cvv: yup.string().min(3).required('Поле обязательное'),
        name: yup.string().min(5, 'Минимум 5 букв').required('Поле обязательное'),
      }),
    }
  },
  computed: {
    isInput() {
      return this.state === stateInput
    },
    isCompleted() {
      return this.state === stateCompleted
    },
    isFailed() {
      return this.state === stateFailed
    },
    isPending() {
      return this.state === statePending
    },
  },
  methods: {
    pay() {
      this.state = statePending

      this.$store
        .dispatch(SEND_PAYMENT, {
          provider: this.provider,
          amount: parseFloat(this.amount),
          currency: 'RUR',
          locationId: window.location.hostname,
          wallet: this.pan,
          extra: {
            pan: this.pan,
            month: this.month,
            year: this.year,
            cvv: this.cvv,
            holder: this.name,
          },
          isSaveWallet: this.isSaveWallet,
        })
        .then(({ data }) => {
          switch (data?.status) {
            case 'action_required':
              if (data?.action?.type === 'redirect') {
                window.location.href = data?.action?.value
              } else if (data?.action?.type === 'script') {
                const tag = document.createElement('script')
                let range = document.createRange()
                let documentFragment = range.createContextualFragment(data.action.value)
                document.head.appendChild(documentFragment)
              }
              break
            case 'completed':
              this.state = stateCompleted
              break
            case 'failed':
              this.failedMessage = data?.message
              this.state = stateFailed
              break
            case 'created':
              this.paymentId = data?.paymentId
              if (this.paymentId) {
                if (data?.paymentData?.payment?.action) {
                  this.handlePaymentAction(data?.paymentData?.payment?.action)
                }
                this.interval = setInterval(() => {
                  this.refreshStatus()
                }, 3000)
              }
          }

          this.isLoading = false
        })
        .catch(e => {
          console.error(e)
          this.isLoading = false
          this.state = stateFailed
          toast.error('Ошибка пополнения счёта. Убедитесь, что данные карты введены правильно.')
        })
    },
    refreshStatus() {
      this.$store.dispatch(FETCH_PAYMENT_STATUS, { paymentId: this.paymentId }).then(response => {
        switch (response?.data?.status) {
          case 'completed':
            clearInterval(this.interval)
            this.state = stateCompleted
            break
          case 'failed':
            clearInterval(this.interval)
            this.state = stateFailed
            break
        }
        this.payment = response?.data
      })
    },
    handlePaymentAction(action) {
      if (action?.type === 'redirect') {
        postForm(action.url, null, 'GET', '_blank')
      } else if (action?.type === 'redirect_post') {
        postForm(action.url, action?.params || {}, 'POST', '_blank')
      }
    },
    goBack() {
      if (this.interval) {
        clearInterval(this.interval)
      }
      this.$emit('closeModal')
    },
    isNumber(evt) {
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      const keyPressed = evt.key

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    closeCashDesk() {
      if (this.interval) {
        clearInterval(this.interval)
      }
      this.$emit('closeModal')
      this.$router.push({ hash: '' })
    },
    goRetry() {
      this.state = stateInput
    },
  },
}
</script>

<style scoped lang="scss">
.preloader-logo-site {
  width: 50%;
}
.preloader-logo-site-time {
  text-align: center;
}
.iCompleted {
  text-align: center;
  align-content: center;
  height: 100%;
  font-size: 35px;
  color: rgb(129, 193, 5);
}
.iError {
  text-align: center;
  align-content: center;
  height: 100%;
  font-size: 25px;
  color: #f11932;
}
.iError .noRequisites {
  margin-top: 15px;
  font-size: 15px;
  color: #c0c0c0;
}
.iError .noRequisites span {
  color: #c0c0c0;
  display: block;
  margin-top: 10px;
}
.iCompleted button,
.iError button {
  margin-top: 20px;
  border: 0;
}
input.payredirect-status-num-item {
  border: 0;
  color: white;
}
button:disabled,
button:disabled:hover {
  background: #999;
}
</style>
